import { render, staticRenderFns } from "./SurveillanceCommunication.vue?vue&type=template&id=21659959&scoped=true&"
import script from "./SurveillanceCommunication.vue?vue&type=script&lang=js&"
export * from "./SurveillanceCommunication.vue?vue&type=script&lang=js&"
import style0 from "./SurveillanceCommunication.vue?vue&type=style&index=0&id=21659959&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21659959",
  null
  
)

export default component.exports